import { CompanyMetadata } from '__generated__/GQL';

/**
 * Returns whether the current company has been refused,
 * and therefore cannot create an account at Shine
 */
const getIsRefused = (companyMetadata: Pick<CompanyMetadata, 'reviewStatus'>) =>
  companyMetadata.reviewStatus === 'REFUSED';

export default getIsRefused;
